import React from "react";
import { FormattedMessage } from "react-intl";
import {
    CLASS,
    CLIENT,
    DEPENDENT_PERSON,
    DIVISION,
    MEMBER,
} from "./enums/syncElementTypes";
import { FAILURE, STARTED, SUCCESS } from "./enums/syncStatusTypes";

export function getNotificationDetail(
    syncNotification,
    enableHyperlinks = false,
    addUsers = false,
) {
    let messageKey = null;
    const baseUrl = window.location.origin;
    const baseClientUrl = `${baseUrl}/dashboard/clients/${syncNotification.client.clientId}`;
    const clientUrl = `${baseClientUrl}/members`;
    const hyperLinks = {
        PAC: enableHyperlinks ? (
            <a
                href={`${baseClientUrl}/members/${syncNotification.member ? syncNotification.member.memberId : ""}${syncNotification.dependentPerson ? `/dependents/${syncNotification.dependentPerson.dependentPersonId}` : ""}`}
                target="_blank"
            >{`${syncNotification.dependentPerson ? syncNotification.dependentPerson.firstName : ""} ${syncNotification.dependentPerson
                    ? syncNotification.dependentPerson.lastName
                    : ""
                }`}</a>
        ) : (
            `${syncNotification.dependentPerson ? syncNotification.dependentPerson.firstName : ""} ${syncNotification.dependentPerson
                ? syncNotification.dependentPerson.lastName
                : ""
            }`
        ),
        user: syncNotification.user
            ? `${syncNotification.user.firstName} ${syncNotification.user.lastName}`
            : "",
        client: enableHyperlinks ? (
            <a href={clientUrl} target="_blank">
                {syncNotification.client ? `${syncNotification.client.name}` : ""}
            </a>
        ) : syncNotification.client ? (
            syncNotification.client.name
        ) : (
            ""
        ),
        member: enableHyperlinks ? (
            <a
                href={`${baseClientUrl}/members/${syncNotification.member ? syncNotification.member.memberId : ""}/profile`}
                target="_blank"
            >{`${syncNotification.member ? syncNotification.member.firstName : ""} ${syncNotification.member ? syncNotification.member.lastName : ""
                }`}</a>
        ) : (
            `${syncNotification.member ? syncNotification.member.firstName : ""} ${syncNotification.member ? syncNotification.member.lastName : ""
            }`
        ),
        division: enableHyperlinks ? (
            <a href={`${baseClientUrl}/divisions`} target="_blank">
                {syncNotification.division ? `${syncNotification.division.name}` : ""}
            </a>
        ) : (
            `${syncNotification.division ? `${syncNotification.division.name}` : ""}`
        ),
        class_: enableHyperlinks ? (
            <a href={`${baseClientUrl}/classes`} target="_blank">
                {syncNotification.class_ ? `${syncNotification.class_.name}` : ""}
            </a>
        ) : (
            `${syncNotification.class_ ? `${syncNotification.class_.name}` : ""}`
        ),
    };
    const getNotificationMessage = (status, type, messageId) => {
        if (status && type) {
            return <FormattedMessage id={messageId} values={hyperLinks} />;
        }
        return null;
    };

    if (syncNotification.elementType === MEMBER.value) {
        if (syncNotification.status === SUCCESS) {
            messageKey = "notificationSyncSuccessParticipant";
        } else if (syncNotification.status === FAILURE) {
            messageKey = "notificationSyncFailParticipant";
        } else if (syncNotification.status === STARTED) {
            messageKey = "notificationSyncInProgressParticipant";
        }
    } else if (syncNotification.elementType === DEPENDENT_PERSON.value) {
        if (syncNotification.status === SUCCESS) {
            messageKey = "notificationSyncSuccessPAC";
        } else if (syncNotification.status === FAILURE) {
            messageKey = "notificationSyncFailPAC";
        } else if (syncNotification.status === STARTED) {
            messageKey = "notificationSyncInProgressPAC";
        }
    } else if (syncNotification.elementType === DIVISION.value) {
        if (syncNotification.status === SUCCESS) {
            messageKey = "notificationSyncSuccessDivision";
        } else if (syncNotification.status === FAILURE) {
            messageKey = "notificationSyncFailDivision";
        } else if (syncNotification.status === STARTED) {
            messageKey = "notificationSyncInProgressDivision";
        }
    } else if (syncNotification.elementType === CLIENT.value) {
        if (syncNotification.status === SUCCESS) {
            messageKey = "notificationSyncSuccessClient";
        } else if (syncNotification.status === FAILURE) {
            messageKey = "notificationSyncFailClient";
        } else if (syncNotification.status === STARTED) {
            messageKey = "notificationSyncInProgressClient";
        }
    } else if (syncNotification.elementType === CLASS.value) {
        if (syncNotification.status === SUCCESS) {
            messageKey = "notificationSyncSuccessClass";
        } else if (syncNotification.status === FAILURE) {
            messageKey = "notificationSyncFailClass";
        } else if (syncNotification.status === STARTED) {
            messageKey = "notificationSyncInProgressClass";
        }
    }
    const messageStr = addUsers
        ? "clients.client.processSync.notificationsBoard.details.messagesWithUsers"
        : "clients.client.processSync.notificationsBoard.details.messages";
    return getNotificationMessage(
        syncNotification.status,
        syncNotification.elementType,
        `${messageStr}.${messageKey}`,
    );
}



// WEBPACK FOOTER //
// ./src/components/dashboard/synchronization/SynchronizationDataHelper.js